import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AppThemeProvider from "./theme/AppThemeProvider";
import Toaster from "./components/Toaster"; // <-- keep this import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppThemeProvider>
        {/* If AppThemeProvider doesn't include CssBaseline, you can add it there */}
        <App />
        <Toaster /> {/* <-- mount once, after App, inside theme provider */}
      </AppThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
